import React, { forwardRef } from 'react'
import type { KibButtonNewProps } from '@chewy/kib-controls-react'
import { KibButtonNew } from '@chewy/kib-controls-react'
import classNames from 'classnames'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './RhapTextButton.module.scss'

export type RhapTextButtonProps = KibButtonNewProps

const RhapTextButton = forwardRef<HTMLButtonElement, RhapTextButtonProps>(
  ({ className, ...props }, ref) => (
    <KibButtonNew
      {...props}
      className={classNames(styles.textButton, className)}
      ref={ref}
    />
  ),
)

RhapTextButton.displayName = 'RhapTextButton'

export default RhapTextButton
